import React from 'react'
import { Route } from 'react-router-dom'

const PublicRoute = ({ path, ...rest }: any) => {
  return <Route {...rest} />
}

export default PublicRoute
